import type { EAssetType } from "app/UtilitiesAndConstants/types/assetType";

export enum EMarketBuilderTabs {
    WEBSITE = 0,
    INDUSTRY = 1,
}

export enum ESelectDomainOptions {
    WEBSITE = "websites",
    INDUSTRY = "industry",
    MANUAL = "manual",
}

export interface IDomain {
    domain: string;
    favicon?: string;
    section?: ESelectDomainOptions;
    type?: EAssetType;
    id?: string;
    segmentName?: string;
    lastUpdated?: string;
}
export type IDomains = Array<IDomain>;

export const CustomCategoryErrorsKeys = {
    emptyName: "customcategories.wizard.error.emptyname",
    longName: "customcategories.wizard.error.longname",
    duplicateName: "customcategories.wizard.error.duplicatename",
    serverError: "custom.category.server.error",
    invalidCharacter: "custom.category.name.error",
};

export const MAX_ALLOWED_INDUSTRY_NAME = 26;
export const INDUSTRY_OVERVIEW_STATE = "market_research_overview_v2";
export const INDUSTRY_LEADERS_STATE = "digitalsuite_marketresearch_webmarketanalysis_mapping";
